var hasInitialized = false;
function initScreensFeatureFlags() {
  if (hasInitialized) return;
  hasInitialized = true;
  try {
    var { featureFlags } = require("react-native-screens");
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.experiment) {
      featureFlags.experiment.synchronousScreenUpdatesEnabled = true;
      featureFlags.experiment.synchronousHeaderConfigUpdatesEnabled = true;
      featureFlags.experiment.synchronousHeaderSubviewUpdatesEnabled = true;
      featureFlags.experiment.iosPreventReattachmentOfDismissedScreens = true;
    }
  } catch (unused) {
  }
}
export {
  initScreensFeatureFlags
};
//# sourceMappingURL=screensFeatureFlags.native.js.map
